module.exports = __webpack_public_path__ + "static/img/案例配图1.1f56e2c5.png";